export default __webpack_public_path__ + "static/media/img-15-corvus.8e43ce2a.jpg";